import React, { useContext } from "react";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Painting = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
  max-height: 100%;
  width: 100%;
  text-decoration: none;
  color: ${variables.DARK};
  overflow: auto;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 500px) {
    width: 85vw;
  }
`;

const Image = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    color: ${variables.BLACK};
    font-size: ${variables.SMALL_TITLE_FONT};
    font-weight: bold;
    text-align: center;
    pointer-events: none;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(8px) brightness(80%);
    transition: opacity 0.3s ease, backdrop-filter 0.3s ease,
      background-color 0.3s ease;
  }

  &:hover::after {
    content: attr(data-availability);
    opacity: 1;
  }
`;

export const CycleItem = ({ cycleName }) => {
  const usedLanguage = useContext(LanguageContext);

  //const { artworkTitle, artworkCycle } = pl.artworks[cycleName];

  //const { artworkAvailability } = usedLanguage.language.artworks[cycleName];

  let cycleImageId = "";

  if (cycleName === "STRUCTURAL COLLAGE") {
    cycleImageId = "0010";
  } else if (cycleName === "INTERIOR") {
    cycleImageId = "0018";
  } else if (cycleName === "EGG DOMINATION") {
    cycleImageId = "0074";
  } else if (
    cycleName === "RZEŹBA" ||
    cycleName === "SCULPTURE" ||
    cycleName === "SKULPTUR"
  ) {
    cycleImageId = "0076";
  } else if (
    cycleName === "POEZJA" ||
    cycleName === "POETRY" ||
    cycleName === "POESIE"
  ) {
    cycleImageId = "0001";
  } else if (
    cycleName === "INNE" ||
    cycleName === "OTHER" ||
    cycleName === "SONSTIGES"
  ) {
    cycleImageId = "0071";
  }

  return (
    <Painting>
      <Image data-availability={cycleName}>
        <LazyLoadImage
          effect="blur"
          src={
            cycleImageId === "0001"
              ? `./images/poetry/${cycleImageId}/${cycleImageId}-1.jpg`
              : `./images/artworks/${cycleImageId}/${cycleImageId}-1.jpg`
          }
          alt={`${cycleName}, Michał Król - Structuralist`}
          position={"relative"}
          width={"100%"}
          height={"100%"}
        />
      </Image>
    </Painting>
  );
};
